import React, {useContext} from "react";
import {Drawer, makeStyles} from "@material-ui/core";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../ToolBar/ToolBarUtils/ItemTypes";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import RenderComponents from "./RenderByType/RenderComponents";
const useStyles = makeStyles(() => ({
    drawerPaper: props => ({
        position: 'absolute',
        width: '100%',
        background: props.background,
        padding: props.padding,
    })
}))
const SidebarComponent = (props) => {
    const {component: {children = [], styles: sourceStyles}, path, index: parentIndex} = props;
    const {onDropComponent, onDropMultipleComponents, onMoveComponent} = useContext(ScreenDesignerContextNew);
    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.componentTarget,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            let newItem = {...item};
            if (didDrop) {
                return;
            }
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                };
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(item.component, 0, `${path}.children`);
                return
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    item.component = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(item.component, item.from, `${path}.children`, children.length, item.index, parentIndex);
                return
            }

            onDropComponent(newItem, children.length, `${path}.children`)
        }
    });
    const hasChildren = children && children.length;
    const styles = sourceStyles ? sourceStyles[0] : {};
    const classes = useStyles(styles);
    return (
        <div style={{width: 300}}>
            <Drawer open={true} variant={"permanent"} anchor="left"
                    style={{
                        background: styles.background,
                        padding: styles.padding
                    }}
            classes={{
                paper: classes.drawerPaper
            }}
            >
                <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}
                     ref={drop}
                >
                    {hasChildren ? (
                        children.map((item, index) => {
                            return (
                                <RenderComponents
                                    key={index}
                                    type={item.type}
                                    item={item}
                                    index={index}
                                    path={`${path}.children.${index}`}
                                    parentPath={path}
                                />
                            )
                        })
                    ) : (
                        isOverCurrent && (
                            <div style={{background: '#009688', height: 10, alignSelf: 'center', width: '100%'}}>

                            </div>
                        )
                    )}
                </div>
            </Drawer>
        </div>

    )
}

export default SidebarComponent;